import { render, staticRenderFns } from "./OptionsParameterValue.vue?vue&type=template&id=80f68c0c&scoped=true&"
import script from "./OptionsParameterValue.vue?vue&type=script&lang=ts&"
export * from "./OptionsParameterValue.vue?vue&type=script&lang=ts&"
import style0 from "./OptionsParameterValue.vue?vue&type=style&index=0&id=80f68c0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f68c0c",
  null
  
)

export default component.exports